/* tslint:disable */

declare var Object: any;
export interface ViewCareerReportInterface {
  "empId"?: string;
  "fullName"?: string;
  "effectivedt": Date;
  "positionName"?: string;
  "careertransitionCode": string;
  "careertranstype"?: string;
  "careertransDtlNameEn"?: string;
  "careerTransition"?: string;
  "historyNo": string;
}

export class ViewCareerReport implements ViewCareerReportInterface {
  "empId": string;
  "fullName": string;
  "effectivedt": Date;
  "positionName": string;
  "careertransitionCode": string;
  "careertranstype": string;
  "careertransDtlNameEn": string;
  "careerTransition": string;
  "historyNo": string;
  constructor(data?: ViewCareerReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewCareerReport`.
   */
  public static getModelName() {
    return "ViewCareerReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewCareerReport for dynamic purposes.
  **/
  public static factory(data: ViewCareerReportInterface): ViewCareerReport{
    return new ViewCareerReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewCareerReport',
      plural: 'ViewCareerReports',
      path: 'ViewCareerReports',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "effectivedt": {
          name: 'effectivedt',
          type: 'Date'
        },
        "positionName": {
          name: 'positionName',
          type: 'string'
        },
        "careertransitionCode": {
          name: 'careertransitionCode',
          type: 'string'
        },
        "careertranstype": {
          name: 'careertranstype',
          type: 'string'
        },
        "careertransDtlNameEn": {
          name: 'careertransDtlNameEn',
          type: 'string'
        },
        "careerTransition": {
          name: 'careerTransition',
          type: 'string'
        },
        "historyNo": {
          name: 'historyNo',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewCareerReport.ts